import React from 'react'

export type StarIconProps = {
  size?: number
  color?: string
  className?: string
}

// Filled star used as the default-floor indicator on Floor Plan lists.
// Defaults to currentColor so it inherits the surrounding text/icon color.
export const StarIcon = ({
  size = 20,
  color = 'currentColor',
  className,
}: StarIconProps) => (
  <svg
    aria-label='Star'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21L12 17.27z'
      fill={color}
    />
  </svg>
)
